import { BaseService } from '@services/BaseService';
import { DocumentHistoryViewModel } from '@models/DocumentHistory';
import { OptionsViewModel } from '@models/common.models';

class DocumentHistoryService extends BaseService {
  constructor() {
    super('contract');
  }

  getDocumentHistory(entityId: number) {
    return this.fetch<DocumentHistoryViewModel[]>(`${entityId}/document`, {
      method: 'GET'
    });
  }

  getDocumentStatuses() {
    return this.fetch<OptionsViewModel[]>('document/status', {
      method: 'GET'
    });
  }
}

export const documentHistoryService = new DocumentHistoryService();



// WEBPACK FOOTER //
// ./src/_services/DocumentHistoryService.ts